/* eslint-disable import/prefer-default-export */
export const NUMBER_OF_ROWS = 30;
export const DEFAULT_ROW_HEIGHT = 65;
export const DEFAULT_HEADER_HEIGHT = 56;
export const DEFAULT_FOOTER_HEIGHT = 69;
export const DEFAULT_ROW_MARGIN = 8;
export const ONBOARDING_ROW_MARGIN = 0;
export const MOBILE_ROW_HEIGHT = 45;
export const MOBILE_ROW_HEIGHT_COMPACT = 31;
export const MOBILE_HEADER_HEIGHT = 56;
export const MOBILE_HEADER_HEIGHT_COMPACT = 39;
export const BORDER_HEIGHT = 1;
export const CREDENTIALS_MIN_HEIGHT = 500;
export const OVERLAYS_MIN_HEIGHT = 500;
export const DETAILED_DATA_GRID_CLASS_NAME = 'detailedDataGrid';
export const DETAILED_SMALL_TEXT_DATA_GRID_CLASS_NAME = 'detailedSmallTextDataGrid';
export const DEFAULT_DATA_GRID_CLASS_NAME = 'defaultDataGrid';
export const DISABLED_ROW_CLASS_NAME = 'MuiDataGrid-row--disabled';
export const DIVIDER_ROW_CLASS_NAME = 'divider-row';
export const FOLIO_CELL_CLASS_NAME = 'folio-cell';
export const HIDE_SCROLLBAR_CLASS_NAME = 'hideScrollbar';
export const DATA_GRID_FORM_CONTROL_CLASS_NAME = 'dataGridFormControl';

export const OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL = {
  sx: {
    overflowX: 'auto',
    overscrollBehaviorX: 'contain',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&': {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto',
      overscrollBehaviorX: 'contain',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '&': {
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      },
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      minWidth: 'fit-content',
    },
  },
};

export const HORIZONTAL_SCROLLBAR_HEIGHT = 12;

export const OUTSIDE_BOX_PROPS_FOR_HORIZONTAL_SCROLL_VISIBLE = {
  showHorizontalScrollbar: true,
  sx: {
    overflowX: 'auto',
    overflowY: 'hidden',
    overscrollBehaviorX: 'contain',
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto',
      overflowY: 'hidden',
      overscrollBehaviorX: 'contain',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      minWidth: 'fit-content',
    },
  },
};
